import {brands} from '@daedalus/core/src/brand/config'

/**
 * @deprecated It is better to use the brand value from the store using the selectors from `@daedalus/core/src/_web/brand/modules/selectors`.
 * Only use this util to populate the store or when it is impossible to use a selector.
 */
export const getCurrentBrand = () => brands.vio

export {defaultBrand as default} from '@daedalus/core/src/brand/config'
